import { render, staticRenderFns } from "./GridHeaderTitleRender.vue?vue&type=template&id=2c965731&"
import script from "./GridHeaderTitleRender.vue?vue&type=script&lang=js&"
export * from "./GridHeaderTitleRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports